import { Stack } from '@mui/material';
import { LinkArrowLeft2 } from 'Components';
import { LinkArrowLeft } from 'Components/LinkArrowLeft';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';

interface IEntitlementLinks {
  instruction: string;
  activation: string;
}

export const EntitlementLinks = ({
  instruction,
  activation,
}: IEntitlementLinks) => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.CompassRights
  ).entitlements;

  return (
    <Stack
      direction='column'
      gap='20px'
      margin='0 0 30px 0'
      aria-label={dictionary.linksAriaLabel}
    >
      {instruction ? (
        <LinkArrowLeft2
          text={dictionary.entitlementOrigin + ' ' + instruction}
          href={`https://shikum.mod.gov.il/Directives/${instruction}.pdf`}
          newWindow={true}
          variant={'body3'}
        />
      ) : null}
      {activation ? (
        <LinkArrowLeft2
          text={dictionary.operatingConcept + ' ' + activation}
          href={`https://shikum.mod.gov.il/FormsDocuments/tfisa/${activation}.pdf`}
          newWindow={true}
          variant={'body3'}
        />
      ) : null}
    </Stack>
  );
};
